<template>
  <div class="dropdown d-inline ">
    <Button id="stockProductWarehouseFilter" color="primary" variant="outline" :title="$t('key_warehouses')" class="dropdown-toggle ms-2 " :class="warehouseSelected == '' ? '' : 'active-filter'"
      data-bs-toggle="dropdown" aria-expanded="false">
      <i class="fa-solid fa-warehouse me-1" aria-hidden="true"></i>
    </Button>
    <ul class="dropdown-menu dropdown-menu-lg-start px-2 py-3" aria-labelledby="stockProductWarehouseFilter">
      <li v-for="(item, index) of warehousesData || []" :key="index">
        <button
            class="dropdown-item border-radius-md text-warehouses"
            :class="[filterWarehouseSelected === item.key ? 'active' : '']"
            type="button"
            @click="handleClick(item.key)"
        >
          <span class="btn-inner--icon">
            <i class="fa-solid fa-warehouse me-3"></i>
          </span>
          <span class="btn-inner--text">{{ item.label }}</span>
        </button>
      </li>
      <li>
        <hr class="horizontal dark my-2" />
      </li>
      <li>
        <button class="dropdown-item border-radius-md text-clearfilter" type="button" @click="handleClick('')">
          <span class="btn-inner--icon">
            <i class="fa-solid fa-eraser me-3 text-clearfilter"></i>
          </span>
          <span class="btn-inner--text">{{ $t('key_purchaseStatusFilter_clearFilter') }}</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>

  import { mapState, mapActions } from "vuex";
  import Button from "./../../../../generic_components/Button.vue";

  export default {
    name:"StockProductWarehouseFilterV2",
    components: {
      Button
    },
    props: {
      filterWarehouseSelected: {
        type: String,
        default: () => ''
      }
    },
    emits: ['stock-product-warehouse-filter-change'],
    data() {
      return {
        myAccount: JSON.parse(localStorage.getItem("user")),
        isLoading: false,
        warehouseSelected: ""
      }
    },
    computed: {
      ...mapState('warehouse', {
        warehousesData: state => state.options.data,
        warehousesStatus: state => state.options.status
      })
    },
    watch: {
      filterWarehouseSelected() {
        this.warehouseSelected = this.filterWarehouseSelected;
      },
      warehousesStatus() {
        this.isLoading = this.warehousesStatus === 'loading';
      }
    },
    mounted () {
      this.getWarehousesList();
    },
    methods: {
      ...mapActions('warehouse', [
                             'getAllWarehousesV2'
                            ]),
      async getWarehousesList() {
        if (this.warehousesStatus === 'loading' || this.isLoading) {
          return;
        }
        
        this.isLoading = true;
        try {
          await this.getAllWarehousesV2();
          
          if (this.warehousesStatus === 'success' && this.myAccount.notifications) {
            this.$notify({
              title: this.$t('key_header_successful_retrieving_data'),
              message: this.$t('key_message_successful_retrieving_data'),
              icon: { component: 'fa-solid fa-check', color: 'white' },
              color: 'success',
              show: true,
              duration: 5000
            });
          } else if(this.warehousesStatus === 'error') {
            this.$notify({
              title: this.$t('key_header_error_retrieving_data'),
              message: this.$t('key_message_error_retrieving_data'),
              icon: { component: 'fa-solid fa-xmark', color: 'white' },
              color: 'danger',
              show: true,
              duration: 5000
            });
          }
        }
        catch (error) {
          this.$notify({
            title: this.$t('key_header_error_unexpected'),
            message: this.$t('key_message_error_unexpected'),
            icon: { component: 'fa-solid fa-xmark', color: 'white' },
            color: 'danger',
            show: true,
            duration: 5000
          });
        }
        finally {
          this.isLoading = false;
        }
      },
      handleClick(warehouse) {
        this.warehouseSelected = warehouse;
        this.$emit('stock-product-warehouse-filter-change', warehouse);

        const dropdownElement = document.querySelector('.dropdown-menu.show');
        if (dropdownElement) {
          dropdownElement.classList.remove('show');
        }
      },
    }
  }

</script>

<style scoped>
  .active{
    background-color: rgb(234, 244, 247) !important;
  }
  .active-filter {
    color: #fff;
    background-color: #42695c;
    border-color: #42695c;
  }
</style>